import { useTranslation } from "react-i18next";

import { useDialog, useDrawer } from "@digital-services/ui";
import { IUseDrawer } from "@digital-services/ui/types";

export const useDrawerWithConfirm = () => {
  const { showDrawer, hideDrawer } = useDrawer();

  const { showDialog } = useDialog();
  const { t } = useTranslation();
  const { t: tCommon } = useTranslation(undefined, { keyPrefix: "common" });

  const customShow = (drawerInstance: IUseDrawer) => {
    return showDrawer({
      ...drawerInstance,
      title: drawerInstance?.title || ""
      // Because of IUseDrawer interface omits onClose we can't provide our version of callback
      // it is not clear why Team Duck implemented it this way while ago.
    });
  };

  const customHide = (isFormTouched?: boolean) => {
    if (isFormTouched) {
      showDialog({
        variant: "warning",
        header: tCommon("hideDrawer.confirm.title"),
        content: tCommon("hideDrawer.confirm.message"),
        confirmButton: t("buttons.confirm.label"),
        onConfirm: () => {
          hideDrawer();
        },
        cancelButton: t("buttons.cancel.label"),
        onCancel: () => {
          /* Do nothing */
        }
      });
    } else {
      hideDrawer();
    }
  };

  return { showDrawer: customShow, hideDrawer: customHide };
};
